import Icon from 'components/Icon/Icon';
import './Drawer.css';

type CustomDrawerProps = {
  children: JSX.Element;
  anchor?: 'left' | 'right';
  isOpen: boolean;
  onClose: () => void;
};

function Drawer({ children, anchor = 'right', isOpen, onClose }: CustomDrawerProps) {
  return (
    <div>
      <div className={`drawer ${anchor} ${isOpen ? 'open' : ''}`}>
        <button
          className="absolute top-4 left-4 p-2 rounded-full hover:text-gray-800 text-gray-400 transition-colors z-10"
          onClick={onClose}
          aria-label="Close drawer"
        >
          <Icon name="XMarkIcon" className="w-5 h-5" />
        </button>
        <div className="drawer-content">{children}</div>
      </div>
      {isOpen && <div className="drawer-overlay" onClick={onClose} />}
    </div>
  );
}

export default Drawer;
